module.exports = __webpack_public_path__ + "static/media/dent4.1e2c0171.webp";